<template>
  <div class="report">
    <headd :mobile_title="mobile_title"></headd>
    <div class="coupon_title hidden-sm hidden-xs">记账申报</div>
    <div class="select container">
      <select @change="getCompanysSelected($event)"
        ><option v-for="item in companys" :value="item.credit_code">{{
          item.company_title
        }}</option></select
      >
    </div>
    <div class="list container" v-if="jizhangDeatils.length > 0">
      <div class="item" v-for="item in jizhangDeatils" :key="item.id">
        <div class="name">{{ item.month }}</div>
        <div class="btn" @click="goView(item.filepath)">点击查看</div>
      </div>
    </div>

    <div class="list_nodata" v-else>
      <div class="nodata_icon">
        <img src="../../../static/order/icon_6.png" />
      </div>
      <div class="nodata_text">未查询到相关数据</div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { getcwjizhangPage, getcwJizhangQuery } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "记账申报",
      index: 0,
      companys: [],
      credit_code: "",
      jizhangDeatils: []
    };
  },
  mounted() {
    this.myjizhanglist();
  },
  components: {
    headd,
    foot
  },
  methods: {
    async myjizhanglist() {
      var _self = this;
      var data = {
        uid: localStorage.getItem("userId")
      };
      const res = await getcwjizhangPage(data);
      // _self.companys = res.data.data.companys
      _self.companys = [
        {
          credit_code: "请选择",
          company_title: "请选择"
        },
        ...res.data.data.companys
      ];
    },
    async myJizhangQueryList() {
      var _self = this;
      var data = {
        uid: localStorage.getItem("userId"),
        credit_code: _self.credit_code
      };
      const res = await getcwJizhangQuery(data);
      console.log(res);
      _self.jizhangDeatils = res.data.data.jizhangDeatils;
    },
    getCompanysSelected(e) {
      var _self = this;

      _self.credit_code = e.target.value;
      _self.myJizhangQueryList();
    },

    goView(urlnew) {
      //let url = urlnew
      let url = JSON.parse(urlnew)[0].filepath;
      console.log(url);
      window.open(url, "_blank");
    }
  },
  onShow() {
    this.myjizhanglist();
  }
};
</script>

<style lang="less" scoped>
.report {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  border-top: 0.02rem solid #f5f5f5;
  .coupon_title {
    font-size: 0.26rem;
    margin: 0.32rem auto;
    width: 8rem;
    text-align: left;
  }
  .select {
    margin: 0.37rem auto;
    height: 0.7rem;
    background: rgba(196, 196, 204, 0.19);
    border-radius: 0.35rem;
    width: 8rem;

    align-items: center;
    justify-content: space-between;
    padding: 0rem 0.2rem;
    font-size: 0.24rem;
    color: #1b1c33;
    display: flex;
    @media (max-width: 991px) {
      width: 6.86rem !important;
      font-size: 0.28rem;
      padding: 0 0.2rem !important;
    }
    select {
      width: 100%;
      height: 100%;
      border: 0;
      background: none;
    }
  }
  .list {
    flex-direction: column;
    width: 8rem;
    @media (max-width: 991px) {
      width: 6.86rem !important;
      padding: 0;
    }
    .item {
      padding: 0rem;
      width: ~"calc(100% - 0rem)";

      align-items: center;
      justify-content: space-between;
      border-bottom: 0.01rem solid #eeeeee;
      display: flex;
      .name {
        font-size: 0.18rem;
        color: #1b1c33;
        margin-right: 0.35rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
      }
      .btn {
        font-size: 0.16rem;
        color: #1395ff;
        @media (max-width: 991px) {
          font-size: 0.26rem;
          line-height: 0.33rem;
        }
      }
    }
  }
  .list_nodata {
    margin: 2.5rem 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
    .nodata_icon {
      width: 3.83rem;
      height: 2.72rem;
      margin-bottom: 0.6rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nodata_text {
      font-size: 0.2rem;
      color: #8d8e99;
      line-height: 0.3rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.33rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/report/report_manage.vue